@if (isLoading()) {
<app-spinner data-test-id="step-challenge-view-spinner"></app-spinner>
} @else if (isResultsView()) {
<div class="challenge-live-content">
  <app-card [size]="'large'" [fullHeight]="true">
    <app-title-section
      title="{{ 'challenges.selectChallenge' | translate }}"
      [size]="3"
      [backButton]="true"
      [spacingBottom]="TitleSpacing.LARGE"
      (handlePressBack)="goBack()"
      data-test-id="step-challenge-view-back"
    ></app-title-section>
    <div class="challenge-overview">
      <app-title-section
        [title]="challenge()?.name"
        [subTitle]="challengeDates()"
        [size]="1"
        [backButton]="false"
        [spacingBottom]="0"
      ></app-title-section>
      @if (challengeStatus() === MetricChallengeViewStatus.ENDED) {
      <app-chip
        [color]="ChipColor.NAVY"
        [size]="ChipSize.LARGE"
        [value]="challengeStatus()"
        data-test-id="step-challenge-view-chip-ended"
      ></app-chip>
      } @else {
      <app-chip
        [color]="ChipColor.HYPER_BLUE"
        [size]="ChipSize.LARGE"
        [value]="challengeStatus()"
        data-test-id="step-challenge-view-chip-started"
      ></app-chip>
      }
    </div>

    <app-title-section
      class="challenge-information-section"
      title="{{ 'groupChallenges.challengeInfo' | translate }}"
      [size]="2"
      [body]="challenge()?.description || challenge()?.name"
      [backButton]="false"
      [spacingBottom]="TitleSpacing.X_LARGE"
    ></app-title-section>

    <app-title-section
      title="{{
        isLiveChallenge()
          ? ('groupChallenges.topTeams' | translate)
          : ('groupChallenges.finalScores' | translate)
      }}"
      [size]="2"
      [backButton]="false"
      [spacingBottom]="TitleSpacing.MEDIUM"
    ></app-title-section>
    <div class="team-view-container">
      @for (team of teams(); track $index) {
      <app-challenge-leaderboard-card
        [team]="team"
        [leaderboardHref]="leaderboardHref(team)"
        data-test-id="step-challenge-view-leaderboard-card"
      ></app-challenge-leaderboard-card>
      }
    </div>
  </app-card>
</div>
} @else {
<app-card size="large" [fullHeight]="true">
  <form [formGroup]="stepChallengeForm" data-test-id="step-challenge-view-form">
    <app-title-section
      title="{{ 'challenges.selectChallenge' | translate }}"
      [backButton]="true"
      [size]="3"
      [spacingBottom]="TitleSpacing.LARGE"
      (handlePressBack)="goBack()"
      data-test-id="step-challenge-view-back"
    ></app-title-section>
    <app-title-section
      title="{{ 'challenges.stepChallengeTitle' | translate }}"
      [size]="2"
      [spacingBottom]="40"
      data-test-id="step-challenge-view-title-section"
    ></app-title-section>
    <app-input
      labelData="{{ 'challenges.labelTitle' | translate }}"
      variant="outline"
      width="full"
      spacingBottom="16"
      [maxLength]="255"
      [disabled]="true"
      data-test-id="step-challenge-view-input-title"
      formControlName="title"
    ></app-input>
    <app-input
      labelData="{{ 'challenges.labelDescription' | translate }}"
      variant="outline"
      width="full"
      [multiLine]="true"
      spacingBottom="16"
      formControlName="description"
      [disabled]="true"
      data-test-id="step-challenge-view-input-description"
    ></app-input>
    <div class="duration-row">
      <div class="field-wrapper">
        <app-input
          labelData="{{ 'challenges.labelDuration' | translate }}"
          variant="outline"
          spacingBottom="16"
          type="number"
          width="fixed-number"
          formControlName="duration"
          [disabled]="true"
          data-test-id="step-challenge-view-input-duration"
        ></app-input>
        <app-select-dropdown
          [optionsObj]="durationUnits"
          [showPlaceholder]="false"
          formControlName="durationUnit"
          [disabled]="true"
          height="small"
        ></app-select-dropdown>
      </div>
      <div
        class="goal-group"
        data-test-id="step-challenge-view-daily-step-limit"
      >
        <label class="label"
          >{{ 'challenges.labelDailyStepLimit' | translate }}
          <span class="secondary-label">{{
            'challenges.labelDailyStepLimitSecondary' | translate
          }}</span></label
        >
        <app-select-dropdown
          [optionsObj]="dailyStepLimitOptions"
          [showPlaceholder]="false"
          formControlName="dailyStepLimit"
          [disabled]="true"
          height="small"
        ></app-select-dropdown>
      </div>
    </div>

    <app-title-section
      title="Team Assignment"
      [size]="2"
      [spacingBottom]="16"
    ></app-title-section>
    <div
      class="team-assigment-options"
      data-test-id="step-challenge-view-team-assignment-options"
    >
      @for (option of teamAssignmentOptions; track option.type) {
      <div class="team-assigment-option">
        <app-toggle
          [checked]="teamAssignmentType() === option.type"
          [disabled]="true"
          color="#14E25A"
          size="small"
          [attr.data-test-id]="getAssignmentDataTestId(option.type)"
        ></app-toggle>
        <app-text color="neutral-7" [size]="16" [spacingBottom]="24">{{
          option.label | translate
        }}</app-text>
      </div>
      }
    </div>
    <div>
      @if (teamAssignmentType() === stepChallengeTeamAssignmentType.DEFAULT) {
      <app-text
        color="neutral-7"
        [size]="16"
        [spacingBottom]="8"
        class="team-assigment-title"
        data-test-id="step-challenge-view-default-assignment-title"
        >{{
          'groupChallenges.defaultTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        color="neutral-6"
        [size]="14"
        [weight]="400"
        [height]="22"
        [spacingBottom]="24"
        data-test-id="step-challenge-view-default-assignment-requirement"
        >{{
          'groupChallenges.defaultTeamAssignmentRequirement' | translate
        }}</app-text
      >
      } @else if (teamAssignmentType() ===
      stepChallengeTeamAssignmentType.FIXED_TEAM_COUNT) {
      <app-text
        color="neutral-7"
        [size]="16"
        [spacingBottom]="8"
        class="team-assigment-title"
        data-test-id="step-challenge-view-fixed-team-count-assignment-title"
        >{{
          'groupChallenges.fixCountTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        color="neutral-6"
        [size]="14"
        [weight]="400"
        [height]="22"
        [spacingBottom]="24"
        data-test-id="step-challenge-view-fixed-team-count-assignment-requirement"
        >{{
          'groupChallenges.fixCountTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <app-input
        labelData="{{
          'groupChallenges.fixCountTeamAssignmentNote' | translate
        }}"
        variant="outline"
        width="fixed-number"
        type="number"
        formControlName="numberOfTeams"
        spacingBottom="40"
        [disabled]="true"
        data-test-id="step-challenge-view-input-number-of-teams"
        [maxLength]="3"
      ></app-input>
      } @else if (teamAssignmentType() ===
      stepChallengeTeamAssignmentType.MAX_TEAM_SIZE) {
      <app-text
        color="neutral-7"
        [size]="16"
        [spacingBottom]="8"
        class="team-assigment-title"
        data-test-id="step-challenge-view-fixed-team-size-assignment-title"
        >{{
          'groupChallenges.maxTeamAssignmentStrategyTitle' | translate
        }}</app-text
      >
      <app-text
        color="neutral-6"
        [size]="14"
        [weight]="400"
        [height]="22"
        [spacingBottom]="24"
        data-test-id="step-challenge-view-fixed-team-size-assignment-requirement"
        >{{
          'groupChallenges.maxTeamAssignmentRequirement' | translate
        }}</app-text
      >
      <app-input
        labelData="{{ 'groupChallenges.maxTeamAssignmentNote' | translate }}"
        variant="outline"
        type="number"
        width="fixed-number"
        formControlName="maxTeamNumber"
        spacingBottom="40"
        [disabled]="true"
        data-test-id="step-challenge-view-input-max-team-number"
        [maxLength]="3"
      ></app-input>
      }
    </div>

    <app-title-section
      title="Dates"
      [size]="2"
      [spacingBottom]="24"
    ></app-title-section>
    <app-input
      labelData="{{ 'challenges.signupDate' | translate }}"
      info="{{ 'challenges.signupDateInfo' | translate }}"
      variant="outline"
      type="date"
      width="fixed-date"
      spacingBottom="16"
      formControlName="signupDate"
      [disabled]="true"
      data-test-id="step-challenge-view-input-signup-date"
    ></app-input>
    <div class="date-row">
      <app-input
        labelData="{{ 'challenges.startDate' | translate }}"
        info="{{ 'challenges.startDateInfo' | translate }}"
        variant="outline"
        type="date"
        width="fixed-date"
        formControlName="startDate"
        [disabled]="true"
        data-test-id="step-challenge-view-input-start-date"
      ></app-input>
      <app-input
        labelData="{{ 'challenges.endDate' | translate }}"
        type="date"
        info="{{ 'challenges.endDateInfo' | translate }}"
        width="fixed-date"
        formControlName="endDate"
        [disabled]="true"
        data-test-id="step-challenge-view-input-end-date"
      ></app-input>
    </div>
    <div class="challenge-options" data-test-id="step-challenge-view-options">
      <app-toggle
        [checked]="isCanJoinAfterStart()"
        [disabled]="true"
        color="#14E25A"
        size="small"
        data-test-id="step-challenge-view-toggle-allow-joining"
      ></app-toggle>
      <app-text color="neutral-7" [size]="16">{{
        'challenges.allowJoiningAfterStartHeader' | translate
      }}</app-text>
      <app-text
        class="challenge-options-body"
        color="neutral-6"
        [size]="14"
        [weight]="400"
        [height]="22"
        >{{ 'challenges.allowJoiningAfterStartBody' | translate }}</app-text
      >
    </div>
  </form>
</app-card>
}
